import React from "react";
import HeroSection from "../components/Services/TransitionSupport/HeroSection";
import Welcome from "../components/Services/TransitionSupport/Welcome";
import Stats from "../components/Services/TransitionSupport/Stats";
import Slider from "../components/Services/TransitionSupport/Slider";
import Contact from "../components/Services/TransitionSupport/Contact";

const TransitionSupport = () => {
  return (
    <>
      <HeroSection />
      <Welcome />
      <Stats />
      <Slider />
      <Contact />
    </>
  );
};

export default TransitionSupport;
